import type { ComponentProps } from 'react'
import { useId } from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '~/components/ui/card'

type Props = Omit<ComponentProps<typeof Card>, 'onChange' | 'title'> & {
  title: string
  label: string
  help: string
  checked: boolean
  onCheckedChange: (checked: boolean) => void
}

/**
 * Carte de réglage tout-ou-rien : un intitulé, une case, ce qu'elle
 * déclenche. Les autres attributs (ancre de visite…) vont à la carte.
 */
function SettingToggleCard({ title, label, help, checked, onCheckedChange, ...card }: Props) {
  const helpId = useId()
  return (
    <Card {...card}>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-2">
        <label className="flex cursor-pointer items-center gap-2 text-sm">
          <input type="checkbox" aria-describedby={helpId} checked={checked} onChange={e => onCheckedChange(e.target.checked)} />
          {label}
        </label>
        <p id={helpId} className="text-xs text-muted-foreground">{help}</p>
      </CardContent>
    </Card>
  )
}

export default SettingToggleCard
